import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Slider,
  Stack,
  Toolbar,
  IconButton, Link as MuiLink
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Delete as DeleteIcon } from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import Footer2 from '../Footer/Footer2';
import Header1 from '../Header/Header1';
import Platform from '../Platform/Platform';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link, useLocation, useNavigate, } from 'react-router-dom';



const API_URL = process.env.REACT_APP_API_URL;

export default function CreateSeriesForm({ onLogout }) {
    const [type, setType] = useState("session"); // default

  const { userId } = useAuth();
  const [languages, setLanguages] = useState([]);
  const [post, setPost] = useState({
    price: 0,
    language: '',
    selectedDate: null,
    startTime: null,
    duration: 30,
    description: '',
    title: '',
    media: null,
  });
  const [previewPostMedia, setPreviewPostMedia] = useState(null);
  const [bundles, setBundles] = useState([]);
  const [bundlePreviews, setBundlePreviews] = useState({});
  const [loading, setLoading] = useState(false); // to track check status
  const [loadingSeconds, setLoadingSeconds] = useState(0);
  const [status, setStatus] = useState(null);
  const [id, setId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let timer;

    if (loading) {
      setLoadingSeconds(0); // reset timer
      timer = setInterval(() => {
        setLoadingSeconds(prev => prev + 1);
      }, 1000);
    } else {
      clearInterval(timer);
      setLoadingSeconds(0); // optional reset after done
    }

    return () => clearInterval(timer); // cleanup on unmount or loading = false
  }, [loading]);


  useEffect(() => {
    axios.get(`${API_URL}/api/languages/`).then((res) => {
      setLanguages(res.data);
    });
  }, []);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const handlePostChange = (e) => {
  const { name, value, files } = e.target;

  if (name === 'media' && files?.[0]) {
    const file = files[0];

    if (file.size > MAX_FILE_SIZE) {
      alert('File size must be less than 5 MB');
      e.target.value = ''; // reset file input
      return;
    }

    setPost((prev) => ({ ...prev, media: file }));

    setPreviewPostMedia({
      url: URL.createObjectURL(file),
      type: file.type,
    });
  } else {
    setPost((prev) => ({ ...prev, [name]: value }));
  }
};


  // const handlePostChange = (e) => {
  //   const { name, value, files } = e.target;

  //   if (name === 'media' && files?.[0]) {
  //     const file = files[0];

  //     // Update media file in post state
  //     setPost((prev) => ({ ...prev, media: file }));

  //     // Save both URL and MIME type
  //     setPreviewPostMedia({
  //       url: URL.createObjectURL(file),
  //       type: file.type,
  //     });
  //   } else {
  //     setPost((prev) => ({ ...prev, [name]: value }));
  //   }
  // };

  // const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const handleBundleChange = (index, e) => {
  const { name, value, files } = e.target;
  const updated = [...bundles];

  if (name === 'media' && files?.[0]) {
    const file = files[0];

    if (file.size > MAX_FILE_SIZE) {
      alert('File size must be less than 5 MB');
      e.target.value = ''; // reset input
      return;
    }

    updated[index][name] = file;

    setBundlePreviews((prev) => ({
      ...prev,
      [index]: {
        url: URL.createObjectURL(file),
        type: file.type,
      },
    }));
  } else {
    updated[index][name] = value;
  }

  setBundles(updated);
};



  // const handleBundleChange = (index, e) => {
  //   const { name, value, files } = e.target;
  //   const updated = [...bundles];

  //   if (name === 'media' && files?.[0]) {
  //     const file = files[0];
  //     updated[index][name] = file;

  //     // Save preview with file type
  //     setBundlePreviews((prev) => ({
  //       ...prev,
  //       [index]: {
  //         url: URL.createObjectURL(file),
  //         type: file.type,
  //       },
  //     }));
  //   } else {
  //     updated[index][name] = value;
  //   }

  //   setBundles(updated);
  // };


  const handleDateChange = (index, date) => {
    const updated = [...bundles];
    updated[index].selectedDate = date;
    setBundles(updated);
  };

  const handleTimeChange = (index, time) => {
    const updated = [...bundles];
    updated[index].startTime = time;
    setBundles(updated);
  };

  const addBundle = () => {
    setBundles((prev) => [
      ...prev,
      {
        session_title: '',
        description: '',
        title: '',
        selectedDate: null,
        startTime: null,
        duration: 30,
        media: null,
      },
    ]);
  };

  const removeBundle = (index) => {
    const updatedBundles = [...bundles];
    updatedBundles.splice(index, 1);
    setBundles(updatedBundles);

    const updatedPreviews = { ...bundlePreviews };
    delete updatedPreviews[index];
    setBundlePreviews(updatedPreviews);
  };

  // const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "video/mp4",
  "video/webm",
  "video/quicktime",
];

const validateFile = (file) => {
  if (!file) return "No file selected";

  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Only images and videos are allowed";
  }

  if (file.size > MAX_FILE_SIZE) {
    return "File size must be less than 5 MB";
  }

  return null;
};

const getMediaTypeFromFile = (file) => {
  if (!file || !file.type) return null;
  if (file.type.startsWith("image/")) return "image";
  if (file.type.startsWith("video/")) return "video";
  return "unknown";
};

const getPresignedUrl = async (file) => {
  const res = await axios.post(`${API_URL}/api/presigned-url/`, {
    file_name: file.name,
    file_type: file.type,
    file_size: file.size,
  });

  return res.data; // { upload_url, key }
};

const uploadToS3 = async (file) => {
  const error = validateFile(file);
  if (error) throw new Error(error);

  const { upload_url, key } = await getPresignedUrl(file);

  await axios.put(upload_url, file, {
    headers: {
      "Content-Type": file.type,
    },
  });

  return key;
};


  const handleSubmit = async () => {
  setLoading(true);

  const formData = new FormData();
  formData.append("user_id", userId);
  formData.append("is_bundle", true);
  formData.append("price", post.price);
  formData.append("language", post.language);
  formData.append("description", post.description);
  formData.append("title", post.title);
  formData.append("type", type);

  // ---------- Main media ----------
  if (post.media) {
    try {
      const mediaKey = await uploadToS3(post.media);
      const mediaType = getMediaTypeFromFile(post.media);

      formData.append("media_key", mediaKey);
      formData.append("media_type", mediaType);
    } catch (err) {
      alert(err.message || "Failed to upload main media");
      setLoading(false);
      return;
    }
  }

  // ---------- Bundles ----------
  for (let i = 0; i < bundles.length; i++) {
    const bundle = bundles[i];

    formData.append(`bundles[${i}][session_title]`, bundle.session_title);
    formData.append(`bundles[${i}][description]`, bundle.description);

    if (bundle.selectedDate) {
      formData.append(
        `bundles[${i}][selectedDate]`,
        bundle.selectedDate.toLocaleDateString("en-CA")
      );
    }

    if (bundle.startTime) {
      formData.append(
        `bundles[${i}][startTime]`,
        bundle.startTime.toTimeString().slice(0, 5)
      );
    }

    formData.append(`bundles[${i}][duration]`, bundle.duration);

    if (bundle.media) {
      try {
        const mediaKey = await uploadToS3(bundle.media);
        const mediaType = getMediaTypeFromFile(bundle.media);

        formData.append(`bundles[${i}][media_key]`, mediaKey);
        formData.append(`bundles[${i}][media_type]`, mediaType);
      } catch (err) {
        alert(
          err.message || `Failed to upload media for session ${i + 1}`
        );
        setLoading(false);
        return;
      }
    }
  }

  // ---------- Create series ----------
  try {
    const res = await axios.post(
      `${API_URL}/api/create-series/`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      }
    );

    setStatus("success");
    setId(res.data.id);
    alert("Series created successfully!");
  } catch (err) {
    console.error(err.response?.data || err.message);
    alert("Error creating series.");
  } finally {
    setLoading(false);
  }
};


  const isActive = (path) => location.pathname === path;


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div>
        <Box
          sx={{
            position: 'fixed', // or 'relative' / 'sticky' based on your layout
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 1300, // higher than MUI drawers (default is 1200)
          }}
        >
          <Header1 onLogout={onLogout} />
        </Box>
        <Box>
          <Platform userId={userId} onLogout={onLogout} />
        </Box>
        <Box position="static" color="primary" sx={{ mt: 5, backgroundColor: '#000000' }}>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 8, mb:2}}>
        <Button
          variant={type === "session" ? "contained" : "outlined"}
          onClick={() => setType("session")}
        >
          Session
        </Button>
        <Button
          variant={type === "ai_immersion" ? "contained" : "outlined"}
          onClick={() => setType("ai_immersion")}
        >
          AI Immersion
        </Button>
      </Box>

          <Toolbar>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 2 }}>

              {/* Single Button */}
              <Button
                variant={isActive('/platform/create') ? 'contained' : 'outlined'}
                color={isActive('/platform/create') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/platform/create')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/platform/create') ? 'secondary.main' : 'transparent',
                  color: isActive('/platform/create') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/platform/create') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/platform/create') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Single
              </Button>

              {/* Multiple Button */}
              <Button
                variant={isActive('/platform/create-series') ? 'contained' : 'outlined'}
                color={isActive('/platform/create-series') ? 'secondary' : 'inherit'}
                onClick={() => navigate('/platform/create-series')}
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  px: 3,
                  py: 1,
                  bgcolor: isActive('/platform/create-series') ? 'secondary.main' : 'transparent',
                  color: isActive('/platform/create-series') ? 'white' : 'inherit',
                  border: '2px solid',
                  borderColor: isActive('/platform/create-series') ? 'primary.main' : 'inherit',
                  '&:hover': {
                    bgcolor: isActive('/platform/create-series') ? 'secondary.dark' : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                Multiple
              </Button>

            </Box>
          </Toolbar>
        </Box>
        <Box
          sx={{
            p: { xs: 2, sm: 3, md: 4 },        // padding adjusts from 2 to 4
            mt: { xs: 4, sm: 6, md: 6 },      // margin-top scales up
            ml: { xs: 2, sm: 7, md: 10 }       // margin-left scales up
          }}
        >


          <Typography
            variant="h3"
            component="h1"
            align="center"
            fontSize={{ xs: '2rem', sm: '2.5rem', md: '2.5rem' }}
            sx={{
              backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
              mb: 5,
              letterSpacing: 7,
              WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
              color: 'transparent',  // Makes the text itself transparent to show the gradient
            }}
            gutterBottom
          >
            Create Multiple Sessions
          </Typography>

          <Box
  sx={{
    maxWidth: 900,
    mx: 'auto',
    px: 2,
    py: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  }}
>
  {/* Title */}
  <TextField
    label="Series Title"
    name="title"
    value={post.title}
    onChange={handlePostChange}
    fullWidth
    multiline
    rows={2}
    placeholder="E.g., Mastering Photography in 30 Days"
    inputProps={{ maxLength: 100 }}
    helperText={`${post.title.length}/100 characters`}
    FormHelperTextProps={{
      sx: {
        textAlign: 'right',
        fontSize: '0.85rem',
        fontWeight: 500,
      },
    }}
    sx={{
      '& .MuiInputBase-root': {
        bgcolor: '#1e1e1e',
        color: '#fff',
        borderRadius: 2,
        lineHeight: 1.6,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#444',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#888',
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
      '& .MuiInputLabel-root': {
        color: '#aaa',
      },
    }}
  />

  {/* Language + Price Row */}
  <Box
    sx={{
      display: 'flex',
      gap: 3,
      flexWrap: 'wrap',
    }}
  >
    {/* Language */}
    <Box sx={{ flex: 1, minWidth: 250 }}>
      <FormControl fullWidth>
        <InputLabel sx={{ color: '#aaa' }}>Language</InputLabel>
        <Select
          name="language"
          value={post.language}
          onChange={handlePostChange}
          label="Language"
          sx={{
            minHeight: 56,
            bgcolor: '#1e1e1e',
            color: '#fff',
            borderRadius: 2,
            '& fieldset': {
              borderColor: '#444',
            },
            '&:hover fieldset': {
              borderColor: '#888',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: '#1e1e1e',
                color: '#fff',
              },
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.id} value={lang.name}>
              {lang.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>

    {/* Price */}
    <Box
      sx={{
        flex: 1,
        minWidth: 250,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Typography fontWeight={500}>
        Price: <strong>₹{post.price}</strong>
      </Typography>

      <Slider
        min={0}
        max={3000}
        step={10}
        value={post.price}
        onChange={(e, value) =>
          setPost((prev) => ({ ...prev, price: value }))
        }
        valueLabelDisplay="on"
        valueLabelFormat={(value) => `₹${value}`}
        sx={{
          color: 'primary.main',
          mt: 2,
          '& .MuiSlider-thumb': {
            height: 24,
            width: 24,
            bgcolor: '#fff',
            border: '2px solid currentColor',
          },
          '& .MuiSlider-rail': {
            opacity: 0.3,
            bgcolor: '#888',
          },
        }}
      />
    </Box>
  </Box>

  {/* Description */}
  <TextField
    label="Series Description"
    name="description"
    value={post.description}
    onChange={handlePostChange}
    fullWidth
    multiline
    rows={4}
    placeholder="Write a detailed and engaging description..."
    inputProps={{ maxLength: 500 }}
    helperText={`${post.description.length}/500 characters`}
    FormHelperTextProps={{
      sx: {
        textAlign: 'right',
        fontSize: '0.85rem',
        fontWeight: 500,
      },
    }}
    sx={{
      '& .MuiInputBase-root': {
        bgcolor: '#1e1e1e',
        color: '#fff',
        borderRadius: 2,
        lineHeight: 1.7,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#444',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#888',
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
      '& .MuiInputLabel-root': {
        color: '#aaa',
      },
    }}
  />

  {/* Upload Media */}
  <Box>

    <Button
  variant="outlined"
  component="label"
  startIcon={<UploadFileIcon />}
  sx={{
    px: 2.5,
    py: 1.2,
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 500,
    bgcolor: '#1E90FF',
    color: '#fff',
    '&:hover': {
      bgcolor: '#046bd1ff',
    },
  }}
>
  Upload Series Media
  {/* <Typography
    variant="caption"
    sx={{ ml: 1, color: 'rgba(255,255,255,0.85)' }}
  >
    (Max 5 MB)
  </Typography> */}
   <Typography variant="caption" sx={{ ml: 1, color: 'rgba(255,255,255,0.8)' }}>
        Max file size: 5 MB (Image/Video accepted)
      </Typography>

  <input
    type="file"
    hidden
    name="media"
    onChange={handlePostChange}
    accept="image/*,video/*"
  />
</Button>

    {/* <Button
      variant="outlined"
      component="label"
      startIcon={<UploadFileIcon />}
      sx={{
        px: 2.5,
        py: 1.2,
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 500,
        bgcolor: '#1E90FF',
        color: '#fff',
        '&:hover': {
          bgcolor: '#046bd1ff',
        },
      }}
    >
      Upload Series Media
      <input
        type="file"
        hidden
        name="media"
        onChange={handlePostChange}
        accept="image/*,video/*"
      />
    </Button> */}

    {previewPostMedia && (
      <Box mt={2}>
        <Typography variant="body2" mb={1}>
          Preview:
        </Typography>

        {previewPostMedia.type.startsWith('video') ? (
          <video
            src={previewPostMedia.url}
            controls
            width="250"
            style={{ borderRadius: 8 }}
          />
        ) : (
          <img
            src={previewPostMedia.url}
            alt="Preview"
            width="250"
            style={{ borderRadius: 8 }}
          />
        )}
      </Box>
    )}
  </Box>
</Box>



          <Box mt={4} maxWidth={920} mx="auto" px={2}>
            

            <Typography
    variant="h6"
    sx={{
      fontWeight: 700,
      letterSpacing: '0.05em',
      color: 'primary.main',
      mb: 2,
      textAlign: { xs: 'center', sm: 'left' },
      textTransform: 'uppercase',
    }}
  >
    Add Sessions
  </Typography>

            {bundles.map((bundle, index) => (
              <Box
  key={index}
  sx={{
    border: '1px solid #333',
    borderRadius: 3,
    p: { xs: 2, sm: 3 },
    mb: 5,
    position: 'relative',
    boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
    backgroundColor: '#121212',
    color: '#f0f0f0',
    maxWidth: 900,
    mx: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  }}
>
  {/* Delete Button */}
  <IconButton
    aria-label="delete"
    onClick={() => removeBundle(index)}
    sx={{
      position: 'absolute',
      top: 12,
      right: 12,
      zIndex: 10,
      bgcolor: '#1e1e1e',
      '&:hover': { bgcolor: '#3a2626' },
    }}
  >
    <DeleteIcon sx={{ color: '#f44336' }} />
  </IconButton>

  {/* Row 1: Title + Date */}
  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
    <Box sx={{ flex: 1, minWidth: 260 }}>
      <TextField
        fullWidth
        label="Session Title"
        name="session_title"
        value={bundle.session_title}
        onChange={(e) => handleBundleChange(index, e)}
        placeholder="Enter a title for this session"
        inputProps={{ maxLength: 100 }}
        helperText={`${bundle.session_title.length}/100 characters`}
        sx={{
          '& .MuiInputBase-root': {
            bgcolor: '#1e1e1e',
            color: '#f0f0f0',
            borderRadius: 2,
            p: 1,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#444',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#777',
          },
          '& .MuiInputLabel-root': {
            color: '#bbb',
          },
        }}
      />
    </Box>

    <Box sx={{ flex: 1, minWidth: 260 }}>
      <DatePicker
        label="Session Date"
        value={bundle.selectedDate}
        onChange={(val) => handleDateChange(index, val)}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                bgcolor: '#1e1e1e',
                color: '#f0f0f0',
                borderRadius: 2,
                p: 1,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#444',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#777',
              },
              '& .MuiInputLabel-root': {
                color: '#bbb',
              },
            }}
          />
        )}
      />
    </Box>
  </Box>

  {/* Row 2: Start Time + Duration */}
  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
    <Box sx={{ flex: 1, minWidth: 260 }}>
      <TimePicker
        label="Session Start Time"
        value={bundle.startTime}
        onChange={(val) => handleTimeChange(index, val)}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                bgcolor: '#1e1e1e',
                color: '#f0f0f0',
                borderRadius: 2,
                p: 1,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#444',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#777',
              },
              '& .MuiInputLabel-root': {
                color: '#bbb',
              },
            }}
          />
        )}
      />
    </Box>

    <Box sx={{ flex: 1, minWidth: 260 }}>
      <Typography sx={{ color: '#ccc', fontWeight: 500, mb: 1 }}>
        Duration: <strong>{bundle.duration} mins</strong>
      </Typography>
      <Slider
        min={10}
        max={180}
        step={10}
        value={bundle.duration}
        onChange={(e, value) => {
          const updated = [...bundles];
          updated[index].duration = value;
          setBundles(updated);
        }}
        sx={{
          color: 'primary.main',
          '& .MuiSlider-thumb': {
            height: 20,
            width: 20,
            bgcolor: '#fff',
            border: '2px solid currentColor',
          },
          '& .MuiSlider-rail': {
            opacity: 0.3,
            bgcolor: '#888',
          },
        }}
      />
    </Box>
  </Box>

  {/* Description */}
  <TextField
    label="Session Description"
    name="description"
    value={bundle.description}
    onChange={(e) => handleBundleChange(index, e)}
    fullWidth
    multiline
    rows={3}
    placeholder="Write a clear and concise description..."
    inputProps={{ maxLength: 500 }}
    helperText={`${bundle.description.length}/500 characters`}
    sx={{
      '& .MuiInputBase-root': {
        bgcolor: '#1e1e1e',
        color: '#f0f0f0',
        borderRadius: 2,
        p: 1.5,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#444',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#777',
      },
      '& .MuiInputLabel-root': {
        color: '#bbb',
      },
    }}
  />

  {/* Upload Media */}
  <Stack spacing={2} maxWidth={300}>
    <Button
  variant="outlined"
  component="label"
  startIcon={<UploadFileIcon />}
  sx={{
    px: 2.5,
    py: 1.2,
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 500,
    bgcolor: '#1E90FF',
    color: '#f0f0f0',
    '&:hover': { bgcolor: '#046bd1' },
  }}
>
  Upload Session Media
  {/* <Typography
    variant="caption"
    sx={{ ml: 1, color: 'rgba(255,255,255,0.8)' }}
  >
    (Max 5 MB)
  </Typography> */}
   <Typography variant="caption" sx={{ ml: 1,color: 'rgba(255,255,255,0.8)' }}>
        Max file size: 5 MB (Image/Video accepted)
      </Typography>

  <input
    type="file"
    hidden
    name="media"
    onChange={(e) => handleBundleChange(index, e)}
    accept="image/*,video/*"
  />
</Button>

    {/* <Button
      variant="outlined"
      component="label"
      startIcon={<UploadFileIcon />}
      sx={{
        px: 2.5,
        py: 1.2,
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 500,
        bgcolor: '#1E90FF',
        color: '#f0f0f0',
        '&:hover': { bgcolor: '#046bd1' },
      }}
    >
      Upload Session Media
      <input
        type="file"
        hidden
        name="media"
        onChange={(e) => handleBundleChange(index, e)}
        accept="image/*,video/*"
      />
    </Button> */}

    {bundlePreviews[index] && (
      <Box>
        <Typography variant="body2" fontWeight={500} mb={1}>
          Preview:
        </Typography>
        <Box
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 0 8px rgba(0,0,0,0.5)',
          }}
        >
          {bundlePreviews[index].type.startsWith('video') ? (
            <video src={bundlePreviews[index].url} controls width="100%" />
          ) : (
            <img src={bundlePreviews[index].url} alt="Preview" width="100%" />
          )}
        </Box>
      </Box>
    )}
  </Stack>
</Box>



            ))}

            <Button
              onClick={addBundle}
              variant="outlined"
              startIcon={<AddCircleOutlineIcon />}
              sx={{
                mt: 2,
                px: 3,
                py: 1.2,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                backgroundColor: '#1E90FF',
                color: '#ccc',
                '&:hover': {
                  backgroundColor: '#046bd1ff',
                },
              }}
            >
              Add Another Session
            </Button>
          </Box>


          {status === 'success' && (
            <Box
              sx={{
                textAlign: "center",
                mt: 5,
                px: 3,
                py: 4,
                borderRadius: "12px",
                backgroundColor: "#001F3F",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
              }}
            >
              <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 40, mb: 2 }} />

              <Typography
                variant="h6"
                sx={{
                  color: "#1E90FF",
                  letterSpacing: 2,
                  fontWeight: 700,
                  fontSize: {
                    xs: "1.1rem",
                    sm: "1.3rem",
                    md: "1.5rem",
                  },
                  lineHeight: 1.6,
                  mb: 1,
                }}
              >
                Series created Successfully!
              </Typography>

              {/* <Typography
                variant="body1"
                sx={{
                  color: "#b0c4de",
                  letterSpacing: 1.5,
                  fontSize: {
                    xs: "0.9rem",
                    sm: "1rem",
                    md: "1.1rem",
                  },
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Please visit{' '}
                <MuiLink
                  component={Link}
                  to={
                    `/my-post-bundle-detail/${id}`
                  }
                  underline="hover"
                  sx={{ color: "#ffffff", fontWeight: "bold" }}
                >
                  My Hosted Sessions
                </MuiLink>{' '}
                to view your updates.
              </Typography> */}

              {/* Create New Button */}
              <Button
                variant="outlined"
                onClick={() => window.location.reload()}
                sx={{
                  mt: 3,
                  color: "#1E90FF",
                  borderColor: "#1E90FF",
                  letterSpacing: 2,
                  '&:hover': {
                    backgroundColor: "#1E90FF",
                    color: "#ffffff",
                  },
                }}
              >
                Create New
              </Button>
            </Box>
          )}
          {loading && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(3px)',
              }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <CircularProgress
                  size={60}
                  thickness={6}
                  sx={{
                    color: 'transparent',
                    '& .MuiCircularProgress-circle': {
                      stroke: 'url(#better-gradient)',
                    },
                  }}
                />

                <svg width="0" height="0">
                  <defs>
                    <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                      <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                      <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                    </linearGradient>
                  </defs>
                </svg>

                <Typography
                  variant="h6"
                  sx={{
                    mt: 2,
                    color: '#fff',
                    textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                  }}
                >
                  Posting Your Series... ({loadingSeconds} sec)
                </Typography>
              </Box>
            </Box>
          )}

          <Box textAlign="center" mt={4}>
  <Button
    onClick={handleSubmit}
    disabled={status === 'success'}
    variant="contained"
    color="primary"
    sx={{
      px: 5,
      py: 1.5,
      fontWeight: 600,
      fontSize: '1.1rem',
      borderRadius: 3,
      boxShadow: '0 4px 15px rgba(30, 144, 255, 0.4)',
      transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
      '&:hover': {
        backgroundColor: 'primary.dark',
        boxShadow: '0 6px 20px rgba(30, 144, 255, 0.7)',
      },
      '&:disabled': {
        backgroundColor: 'grey.500',
        boxShadow: 'none',
        color: 'grey.300',
      },
    }}
  >
    Submit Series
  </Button>
</Box>

        </Box>
        <Footer2 />
      </div>
    </LocalizationProvider>
  );
}
